import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Sales.ContractRefund.GenerateDocuments.IParams;
type Request = Api.Sales.ContractRefund.GenerateDocuments.IRequest;
type Response = Api.Sales.ContractRefund.GenerateDocuments.IResponse;
type Headers = Api.Sales.ContractRefund.GenerateDocuments.IHeaders;
const url = '/api/Sales/ContractRefund/:id/GenerateDocuments';
export default async function contractRefundGenerateDocumentsApi({
  id,
  ...body
}: Params & Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id }, null),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
